import { ReactNode } from 'react';
import { ModalDialog } from 'vetrf-ui';
import {
  CancelButton,
  ConfirmButton,
} from 'vetrf-ui/dist/components/modal/ModalDialog/inner/ConfirmFooterModal/ConfirmFooterModal';

type ConfirmModalProps = {
  onClose: () => void;
  onConfirm?: () => void;
  modalContent: ReactNode;
  header?: string;
  confirmButton?: ConfirmButton;
  cancelButton?: CancelButton;
};

export const ConfirmModal = ({
  onClose,
  onConfirm,
  modalContent,
  header = 'Подтверждение',
  confirmButton,
  cancelButton,
}: ConfirmModalProps) => (
  <ModalDialog
    header={header}
    onClose={onClose}
    confirmBtn={
      !onConfirm
        ? undefined
        : {
            size: 'sm',
            color: 'info',
            text: 'Подтвердить',
            action: onConfirm,
            ...confirmButton,
          }
    }
    cancelBtn={{
      size: 'sm',
      text: 'Отмена',
      ...cancelButton,
    }}
  >
    {modalContent}
  </ModalDialog>
);
